import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireindaundpune() {



const cardData =
  {
    keyword: 'Bus Hire in Daund Pune',
    heading: 'Sanavi Travels: Bus Hire in Daund Pune',
    headingDescription: 'Sanavi Travels provides reliable and professional Bus Hire in Daund Pune, offering safe, spacious, and comfortable transportation for families, large groups, corporate organizations, schools, wedding parties, picnic tours, and outstation travelers. Daund is an important railway junction and commercial center in Pune district, generating frequent movement of people for business, education, social functions, and tourism. To cater to these diverse travel needs, we maintain a wide fleet of AC buses, Non-AC buses, mini buses, luxury coaches, and large seating-capacity buses that are suitable for both short-distance and long-distance journeys. Each bus is designed to provide comfortable seating, proper ventilation, smooth suspension, and sufficient luggage space to ensure a relaxed and enjoyable travel experience. With experienced drivers who are well familiar with Daund routes and highways, flexible rental options including one-way, round-trip, and multi-day packages, transparent pricing with no hidden charges, and 24/7 customer support, bus hire in Daund Pune becomes simple, efficient, and stress-free. Choose Sanavi Travels for trusted bus hire services in Daund Pune, delivering punctuality, comfort, safety, and seamless group transportation for every occasion.',

    top: 'Top Places to Visit in Daund Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Daund City",
    "description": "Daund is a major town in Pune district known for its railway junction, commercial activity, and residential areas. Group travel by bus is common here for social events, corporate travel, and family functions."
  },
  {
    "title": "Daund Railway Junction",
    "description": "One of the busiest railway junctions in Maharashtra, Daund Railway Junction attracts daily travelers, pilgrims, and tourists, making bus hire ideal for group transfers."
  },
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Bhigwan Bird Sanctuary near Daund is famous for migratory birds and scenic backwaters, making it a popular picnic and educational tour destination."
  },
  {
    "title": "Jejuri Khandoba Temple",
    "description": "Jejuri is a renowned pilgrimage site frequently visited by devotees from Daund. Hiring a bus ensures organized and comfortable religious group travel."
  },
  {
    "title": "Industrial and MIDC Areas",
    "description": "Several industrial zones around Daund require regular corporate and employee movement, where bus hire services play a crucial role."
  },
  {
    "title": "Local Markets",
    "description": "Daund’s local markets and trading areas attract visitors from surrounding towns, making group travel by bus convenient and economical."
  },
  {
    "title": "Wedding Venues in Daund",
    "description": "Multiple marriage halls and wedding lawns in Daund depend on bus rentals for guest transportation and smooth event coordination."
  },
  {
    "title": "Picnic and Leisure Spots",
    "description": "Open spaces, riversides, and leisure areas near Daund are popular for school picnics and family outings."
  },
  {
    "title": "Agricultural Villages",
    "description": "Villages surrounding Daund are agriculturally rich and often visited during rural exposure tours and educational trips."
  },
  {
    "title": "Outstation Travel Routes",
    "description": "Daund offers excellent road connectivity to Shirdi, Solapur, Pune, Nashik, Kolhapur, and Mumbai, making it suitable for long-distance bus travel."
  }
]
,



"services": [
{
"name": "Bus Hire in Daund Pune",
"description": "Bus Hire in Daund Pune provides dependable and comfortable buses for families, tourists, schools, corporate clients, and social groups. This service is ideal for weddings, religious tours, picnics, school excursions, corporate events, and long-distance outstation travel. Our buses are spacious, clean, and designed for group comfort with cushioned seating, smooth suspension, proper ventilation, and sufficient luggage space. Experienced drivers ensure disciplined driving, route familiarity, punctual pickups, and safe travel, making every journey smooth and stress-free."
},
{
"name": "Bus Rental Services Daund",
"description": "Bus Rental Services Daund offer flexible transportation solutions for local travel, event-based bookings, and multi-day group journeys. Whether it is a family function, office outing, or social event, these services ensure organized travel with reliable scheduling, professional coordination, and comfortable buses suited to group size and travel distance."
},
{
"name": "AC Bus Hire Daund Pune",
"description": "AC Bus Hire Daund Pune is ideal for travelers seeking maximum comfort, especially during hot weather and long-distance travel. Fully air-conditioned interiors, comfortable seating, controlled airflow, and smooth ride quality make AC buses suitable for corporate travel, weddings, tourist groups, and outstation journeys, ensuring passengers remain relaxed throughout the trip."
},
{
"name": "Non AC Bus Hire Daund",
"description": "Non AC Bus Hire Daund provides economical transportation for short-distance travel, rural routes, school trips, and budget-conscious group journeys. These buses are well-maintained, spacious, and reliable, making them a practical choice without compromising safety."
},
{
"name": "Luxury Bus Hire in Daund",
"description": "Luxury Bus Hire in Daund offers premium travel with modern interiors, elegant seating arrangements, and enhanced comfort features. These buses are ideal for weddings, VIP travel, corporate events, and special occasions where comfort, style, and presentation matter equally."
},
{
"name": "Mini Bus Hire Daund Pune",
"description": "Mini Bus Hire Daund Pune is suitable for small to medium-sized groups such as family outings, office teams, local events, and short tours. Mini buses offer easy maneuverability, comfortable seating, and cost-effective pricing while maintaining safety and reliability."
},
{
"name": "32 Seater Bus Hire Daund",
"description": "32 Seater Bus Hire Daund is perfect for medium-sized groups including school excursions, corporate outings, and social gatherings. These buses offer balanced seating capacity, adequate luggage space, and smooth travel for both local and outstation routes."
},
{
"name": "35 Seater Bus Rental Daund",
"description": "35 Seater Bus Rental Daund supports larger group travel such as weddings, religious tours, school trips, and corporate events. Spacious seating, professional drivers, and dependable service ensure organized and comfortable group transportation."
},
{
"name": "Bus Hire Daund for Wedding",
"description": "Bus Hire Daund for Wedding ensures timely and coordinated transportation for wedding guests, family members, and relatives. These buses help manage large crowds efficiently while ensuring guests reach venues comfortably and on time."
},
{
"name": "Bus Hire Daund for Corporate Events",
"description": "Bus Hire Daund for Corporate Events supports employee transport, conferences, meetings, factory visits, and corporate outings. The service emphasizes punctuality, professionalism, and comfort, helping organizations manage group movement efficiently."
},
{
"name": "Bus Hire Daund for Picnic Tour",
"description": "Bus Hire Daund for Picnic Tour offers safe and convenient transportation for school picnics, family outings, and leisure trips. Group travel by bus ensures coordination, safety, and enjoyable travel experiences."
},
{
"name": "Bus Hire Daund Outstation Travel",
"description": "Bus Hire Daund Outstation Travel provides dependable long-distance transportation to destinations such as Shirdi, Nashik, Solapur, Kolhapur, Pune, and Mumbai. These buses are designed for extended journeys with passenger comfort and safety as top priorities."
},
{
"name": "Bus Hire Daund with Driver",
"description": "Bus Hire Daund with Driver offers chauffeur-driven buses where experienced drivers handle navigation, traffic conditions, and route planning, allowing passengers to relax and enjoy the journey."
},
{
"name": "Cheap Bus Hire Daund Pune",
"description": "Cheap Bus Hire Daund Pune provides budget-friendly transportation solutions for groups seeking economical travel without compromising on cleanliness, safety, or service quality."
},
{
"name": "Best Bus Hire Service Daund",
"description": "Best Bus Hire Service Daund is trusted for clean buses, disciplined drivers, transparent pricing, and customer-focused operations. Sanavi Travels ensures every journey is smooth, punctual, and comfortable."
}
],
"tableData": [
["Bus Hire in Daund Pune", "Bus Rental Services Daund"],
["AC Bus Hire Daund Pune", "Non AC Bus Hire Daund"],
["Luxury Bus Hire in Daund", "Mini Bus Hire Daund Pune"],
["32 Seater Bus Hire Daund", "35 Seater Bus Rental Daund"],
["Wedding Bus Daund", "Corporate Event Bus Daund"],
["Picnic Bus Daund", "Outstation Bus Daund"],
["Bus Hire Daund with Driver", "Cheap Bus Hire Daund Pune"],
["Best Bus Hire Service Daund", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Daund Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels is a trusted name for bus hire in Daund Pune, offering reliable transportation for families, corporate groups, schools, and social events."
  },
  {
    "WhyChooseheading": "Well-Maintained and Spacious Buses",
    "WhyChoosedescription": "Our buses are clean, spacious, and regularly serviced to provide a safe and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are familiar with Daund routes, highways, and outstation destinations, ensuring safe and punctual travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing Policy",
    "WhyChoosedescription": "We follow clear pricing with no hidden charges, offering complete transparency for every booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel planning, and on-trip coordination."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "We offer hourly, full-day, multi-day, and customized bus hire packages based on travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Every bus is thoroughly cleaned and sanitized before each journey to ensure passenger safety."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "We ensure on-time pickups and disciplined operations, making Sanavi Travels a reliable choice for bus hire in Daund Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Daund Pune?',
    answer: 'Yes, Sanavi Travels offers professional bus hire services in Daund Pune for all types of group travel.'
  },
  {
    question: 'How can I book a bus in Daund Pune?',
    answer: 'You can book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available in Daund Pune?',
    answer: 'We provide AC buses, Non-AC buses, mini buses, luxury buses, 32-seater and 35-seater buses.'
  },
  {
    question: 'Is bus hire available for weddings and corporate events?',
    answer: 'Yes, we offer dedicated bus services for weddings, corporate events, and social functions.'
  },
  {
    question: 'Are buses sanitized before every trip?',
    answer: 'Yes, all buses are cleaned and sanitized before each journey.'
  },
  {
    question: 'Is bus service available for outstation travel?',
    answer: 'Yes, we provide bus hire services from Daund Pune to multiple outstation destinations.'
  },
  {
    question: 'What payment options are accepted?',
    answer: 'We accept UPI, debit cards, credit cards, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our customer support team remains available throughout the journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Deshmukh',
    feedback: 'We hired a bus from Daund for a corporate event. Excellent service, clean bus, and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Sanavi Travels arranged a bus for our picnic tour from Daund. Smooth journey and great coordination.',
    rating: 5
  }
];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Daund Pune - Sanavi Travels",
  "description": "Sanavi Travels provides bus hire in Daund Pune for weddings, corporate events, picnic tours, and outstation travel. We offer AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with experienced drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "190"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire in Daund Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire in Daund Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate events, picnic tours, and outstation travel with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/215.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireindaundpune;